import { useMutation } from "urql";

import { UpdateRrAssignedDocument } from "../../../graphql/generated.ts";

export const useUpdateRRAssigned = () => useMutation(UpdateRrAssignedDocument);
